import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Table } from '..';
import { PAYMENT_ORDERS_HEADERS } from '../../constants/table-headers';
import ActivityIndicator from '../ActivityIndicator';
import Pagination from '../atoms/pagination';
import './styles.scss';
import useGetPaymentOrders, {
  GetPaymentOrdersResponse,
  GetPaymentOrdersResponseRow,
} from '../../hooks/payment-orders/useGetPaymentOrders';
import { PaymentOrderStatus } from '../../types/drawer.types';
import Modals from '../Modal';
import useCancelPaymentOrderNfe from '../../hooks/payment-orders/useCancelPaymentOrderNfe';

const TablePaymentOrders: React.FC = () => {

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [status, setStatus] = useState<string | 'Todos'>('Todos');
  const { execute: cancelPaymentOrderNfe } = useCancelPaymentOrderNfe();
  const [callback, setCallback] = useState<{
    message?: string;
    image?: string;
    callback: () => void;
  }>({ message: '', callback: () => null });
  const { execute, loading } = useGetPaymentOrders();
  const [isModal, setIsModal] = useState<boolean>(false);

  const [paymentOrders, setPaymentOrders] = useState<GetPaymentOrdersResponse>({
    rows: [],
    totalRecords: 0,
    page: '1',
  });

  const onCancelNfe = (paymentOrderId: string) => {
    const image = paymentOrders.rows.find(
      cart => cart.paymentOrderId === paymentOrderId,
    )?.nfeUrl;
    if (!image) {
      console.error('Invalid image URL provided');
      return;
    }
    setIsModal(true);
    setCallback({
      callback: async () => {
        await cancelPaymentOrderNfe(paymentOrderId);
        setPaymentOrders(prevCarts => {
          const newCarts = prevCarts.rows.map(
            (oldPaymentOrder: GetPaymentOrdersResponseRow) => {
              if (paymentOrderId === oldPaymentOrder.paymentOrderId) {
                return {
                  ...oldPaymentOrder,
                  status: PaymentOrderStatus.READY_FOR_ISSUANCE,
                };
              }
              return oldPaymentOrder;
            },
          );
          return {
            ...prevCarts,
            rows: newCarts,
          };
        });
      },
      message: 'Deseja reprovar essa nota fiscal?',
      image,
    });
  };

  useEffect(() => {
    const loading = async () => {
      const result = await execute({
        page: currentPage,
        rowsPerPage: 20,
        status,
      });
      if (!result) return;
      setPaymentOrders(result);
    };
    loading();
  }, [currentPage, status]);

  if (loading) {
    return <ActivityIndicator />;
  }
  return (
    <>
      <Modals
        outlined
        onHide={() => {
          setIsModal(false);
        }}
        show={isModal}
        onConfirmClick={callback.callback}
        message={callback.message}
        imgSrc={callback.image}
      />
      <div className="container-table-paymentOrders">
        <div style={{ display: 'flex' }}>
          <FormControl
            style={{
              width: '10%',
              marginTop: '2%',
              display: 'flex',
              justifyItems: 'flex-end',
            }}
            variant="outlined"
          >
            <InputLabel id="select-label-freight-status">Status</InputLabel>
            <Select
              labelId="select-label-freight-status"
              style={{ width: '230%', height: '80%' }}
              id="demo-simple-select"
              label="Status"
              value={status}
              onChange={event => setStatus(event.target.value as string)}
            >
              {[['Todos', 'Todos']]
                .concat(Object.entries(PaymentOrderStatus))
                .map(([key, value]) => (
                  <MenuItem key={key} value={value}>
                    {value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
        <Table
          columns={PAYMENT_ORDERS_HEADERS}
          data={paymentOrders.rows || []}
          onCancelNfe={onCancelNfe}
          notShowInput={true}
        />
        <Pagination
          totalRecords={paymentOrders.totalRecords}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          rowsPerPage={20}
        />
      </div>
    </>
  );
};

export default TablePaymentOrders;
